import { AlertTriangle } from 'lucide-react';
import { formatEuro } from '../../utils/currency';
import { CampaignStatusBadge } from './CampaignStatusBadge';
import type { ProcessedEntry } from '../../types/financialReport';

interface BillingAlertsProps {
  entries: ProcessedEntry[];
  loading: boolean;
}

export function BillingAlerts({ entries, loading }: BillingAlertsProps) {
  if (loading || entries.length === 0) return null;

  const totalExposure = entries.reduce((sum, e) => sum + e.fee, 0);

  return (
    <div className="bg-gradient-to-br from-red-50 to-amber-50 rounded-xl border border-red-100 shadow-sm overflow-hidden">
      <div className="px-6 py-4 border-b border-red-100 flex items-center gap-3">
        <div className="bg-red-100 rounded-lg p-2">
          <AlertTriangle className="w-5 h-5 text-red-600" />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-gray-900">Faturação a precisar de atenção</h3>
          <p className="text-xs text-gray-600">
            {entries.length} em faturação com faturas por pagar · {formatEuro(totalExposure)} em causa
          </p>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-red-50/50">
            <tr>
              <th className="px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Código</th>
              <th className="px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Marca</th>
              <th className="px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Cliente</th>
              <th className="px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Valor</th>
              <th className="px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Estado</th>
              <th className="px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Fatura</th>
              <th className="px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-gray-500">Account</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-red-50">
            {entries.map((entry) => (
              <tr key={entry.id} className="hover:bg-red-50/30 transition-colors">
                <td className="px-4 py-2.5 text-sm font-mono font-medium text-gray-900">{entry.work_code}</td>
                <td className="px-4 py-2.5 text-sm text-gray-700">{entry.brand}</td>
                <td className="px-4 py-2.5 text-sm text-gray-600 max-w-[180px] truncate">{entry.client}</td>
                <td className="px-4 py-2.5 text-sm font-medium text-gray-900">{formatEuro(entry.fee)}</td>
                <td className="px-4 py-2.5"><CampaignStatusBadge status={entry.campaign_status} /></td>
                <td className="px-4 py-2.5 text-xs font-mono text-gray-600">{entry.client_invoice_numbers || 'Por emitir'}</td>
                <td className="px-4 py-2.5 text-sm text-gray-600">{entry.agent}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
